import React, { Component } from "react";
import { connect } from "react-redux";
import { checkAuth, signup } from "../actions/index";
import {
  LOGIN_TYPE,
  //  BASE_LINK, 
  DASHBOARD_LINK
} from "../actions/types";
import qq from "images/qq@2x.png";
import weixin from "images/weixin@2x.png";
import PropTypes from "prop-types";
import Form from "antd/lib/form";
import Input from "antd/lib/input";
import Button from "antd/lib/button";
const FormItem = Form.Item;
let crypto = require("crypto"),
  algorithm = "aes-256-ctr",
  password = "d6F3Efeq";
class Signup extends Component {
  componentDidMount() {
    if (LOGIN_TYPE !== "cas") {
      if (this.getCookie("email") && this.getCookie("password")) {
        document.getElementById("remberPassword").checked = true;
      }
      const initData = {
        //这里可以改为你想要设置的值，前面的键值如“id”要和你Field中的name值相同，
        //我这里调用的是前一个页面传过来的值
        email: this.getCookie("email") || "",
        password: this.getCookie("password") || ""
      };
      this.props.form.setFieldsValue(initData);
    }
    this.props.checkAuth();
  }
  //登陆完成跳转页面
  UNSAFE_componentWillUpdate(next) {
    if (this.props.user === null && next.user !== null) {
      // if (next.user.role === "student") {
      //   this.props.history.push(`${BASE_LINK}`); // 学生跳转去首页
      // } else {
      //   this.props.history.push(`${DASHBOARD_LINK}`); // 其余的身份跳去工作台
      // }
      this.props.history.push(`${DASHBOARD_LINK}`); // 其余的身份跳去工作台
    }
  }
  getCookie(name) {
    let reg = RegExp(name + "=([^;]+)");
    let arr = document.cookie.match(reg);
    if (arr) {
      return arr[1];
    } else {
      return "";
    }
  }
  setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + "=" + value + ";expires=" + date;
  }
  delCookie(name) {
    this.setCookie(name, null, -1);
  }
  onSubmit() {
    let data = this.props.form.getFieldsValue();
    let oldPasswod = data.password
    data.password = this.encrypt(data.password);
    this.props.form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      } else {
        if (document.getElementById("remberPassword").checked) {
          this.setCookie("email", data.email, 7); //保存帐号到cookie，有效期7天
          this.setCookie("password", oldPasswod, 7); //保存密码到cookie，有效期7天
        } else {
          this.delCookie("email");
          this.delCookie("password");
        }
        this.props.signup(data);
      }
    });
  }
  encrypt(text) {
    var cipher = crypto.createCipher(algorithm, password);
    var crypted = cipher.update(text, "utf8", "hex");
    crypted += cipher.final("hex");
    return crypted;
  }
  renderLoginForm() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className='login-bg'>
        <div className="login">
          <div>
            <div className="login-title">智慧门户后台</div>
            <div className="login-title-english">
              Portal Administration Panel
          </div>
          </div>
          <Form action="" className="login-form">
            <FormItem>
              {getFieldDecorator("email", {
                rules: [{ required: true, message: "请输入用户名" }]
              })(<Input placeholder="用户名" />)}
            </FormItem>
            <FormItem>
              {getFieldDecorator("password", {
                rules: [{ required: true, message: "请输入密码" }]
              })(<Input type="password" placeholder="密码" />)}
            </FormItem>
            <p className="pwd-contain" style={{ display: "inline-block" }}>
              <input type="checkbox" id="remberPassword" />
              <label htmlFor="remberPassword" className="color-checkbox" />
              <label htmlFor="remberPassword" className="remberPwd">
                记住密码
            </label>
            </p>
            <Button
              className="loginBtn"
              htmlType="submit"
              onClick={() => this.onSubmit()}
            >
              登 录
          </Button>
          </Form>
          <div className="other-login">
            <div className="other-login-content">
              <span>第三方账号登录</span>
              <div>
                <img src={qq} alt="qq" width="40px" />
                <img src={weixin} alt="weixin" width="40px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  //登陆页还可以进行模块化
  render() {
    return this.renderLoginForm();
  }
}
function mapStateToProps(state) {
  const { user, error, loading } = state.auth;
  return { user, error, loading };
}

Signup.propTypes = {
  checkAuth: PropTypes.func,
  signup: PropTypes.func
};

export default connect(
  mapStateToProps,
  { checkAuth, signup }
)(Form.create()(Signup));
